module.exports = __webpack_public_path__ + "static/img/about_header.bea74758.jpg";